<template>
  <div class="u-wrap">
    
    <div class="u-content-wrap">
      <van-empty v-if="!loading&&dataList.length == 0" style="width: 100%;" description="暂无数据" />
      <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" offset="20" :finished="finished" finished-text="" @load="onLoad">
            <div class="lxwg-item" v-for="(item,index) in dataList" :key="index">
              <div class="lxwg-n">{{item.pqName}}</div>
              <span class="lxwg-dhhm" @click="clickBddh(item.lxfs)">{{item.lxfs}}</span>
            </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'

export default {
  data() {
    return {
      dataList: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 0,
      
    }
  },
  created() {
    this.onRefresh()
  },
  computed: {},
  methods: {
    getData() {
      let params = { pageNo: this.pageNo, pageSize:'30', }
      getAction('/zhshj/csqryglwgy/getSmrzPq', params).then((res) => {
        if (res.success) {
          if (this.refreshing) {
            this.dataList = []
            this.refreshing = false
          }
          let list = res.result.records
          this.dataList = this.dataList.concat(list)
          this.loading = false
          if (res.result.pages <= this.pageNo) {
            this.finished = true
          }
        }
      })
    },
    onLoad() {
      this.pageNo++
      this.getData()
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.pageNo = 0
      this.refreshing = true
      this.onLoad()
    },
    clickBddh(dhhm){
      window.location.href = `tel:${dhhm}`
    }
  },
}
</script>

<style lang="less" scoped>
*{
  box-sizing: border-box;
}
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #F9F9F9;
}

.lxwg-item{
  display: flex;
  padding: 16px 12px;
  font-size: 15px;
  border-bottom: 1px solid #dedede;
  background: #FFF;
  .lxwg-n{
    flex: 1;
    color: #1A1A1A;
   
  }
  .lxwg-dhhm{
    color:#1D6DDB ;
    flex-shrink: 0;
  }
}
/deep/ .van-pull-refresh {
   min-height:100vh
}
</style>
